<template>
  <div class="sunmap-search-wrapper" :class="{ 'not-intro': !showIntro }">
    <div class="sunmap-search" :class="{ 'not-intro': !showIntro }">
      <svg viewBox="0 0 24 24" v-if="!isLoading">
        <path
          xmlns:default="http://www.w3.org/2000/svg"
          d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        />
      </svg>
      <svg
        viewBox="0 0 44 44"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#000"
        v-if="isLoading"
      >
        <g fill="none" fill-rule="evenodd" stroke-width="2">
          <circle cx="22" cy="22" r="1">
            <animate
              attributeName="r"
              begin="0s"
              dur="1.8s"
              values="1; 20"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.165, 0.84, 0.44, 1"
              repeatCount="indefinite"
            />
            <animate
              attributeName="stroke-opacity"
              begin="0s"
              dur="1.8s"
              values="1; 0"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.3, 0.61, 0.355, 1"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="22" cy="22" r="1">
            <animate
              attributeName="r"
              begin="-0.9s"
              dur="1.8s"
              values="1; 20"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.165, 0.84, 0.44, 1"
              repeatCount="indefinite"
            />
            <animate
              attributeName="stroke-opacity"
              begin="-0.9s"
              dur="1.8s"
              values="1; 0"
              calcMode="spline"
              keyTimes="0; 1"
              keySplines="0.3, 0.61, 0.355, 1"
              repeatCount="indefinite"
            />
          </circle>
        </g>
      </svg>
      <input
        type="text"
        v-model="search"
        v-on:keyup="handleKeyPress"
        autocomplete="new-password"
        role="combobox"
        placeholder="Søk opp din adresse"
        aria-label="Søk opp din adresse"
      />
      <ul class="sunmap-search__results" v-if="items.length > 0">
        <li
          v-for="(item, index) of items"
          :key="index"
          v-on:click="goto(item)"
          :class="{
            'sunmap-search__results--selected': index === selectedItemIndex,
          }"
        >
          {{ item.Text }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from '../store';
import axios from 'axios';
import config from '../../common/config.js';
import _ from 'lodash';

export default {
  name: 'Search',
  data() {
    return {
      //model: {},
      search: null,
      result: {},
      isLoading: false,
      cancelToken: false,
      items: [],
      selectedItemIndex: 0,
    };
  },
  computed: {
    results() {
      return this.items;
    },
    showIntro() {
      return store.state.showIntro;
    },
  },
  methods: {
    // eslint-disable-next-line no-undef
    doSearch: _.debounce(function(val, oldval) {
      this.isLoading = true;
      if (this.cancelToken || val === oldval) {
        this.cancelToken.cancel();
      }
      this.cancelToken = axios.CancelToken.source();

      axios
        .get(
          `//www.webatlas.no/waapi-fritekstsok/search/matrikkel/adresse/gateadresse?query=${val}&api_key=${config.apiKey}&format=json`
        )
        .then(response => {
          this.items = response.data.SearchResults;
          this.isLoading = false;
        })
        .catch(err => {
          /* eslint-disable no-console */
          console.log(err);
          this.isLoading = false;
          return err;
        });
    }, 500),
    handleKeyPress: function(event) {
      if (event.keyCode === 40) {
        //arrow down
        if (this.selectedItemIndex < this.items.length - 1) {
          this.selectedItemIndex++;
        } else {
          this.selectedItemIndex = 0;
        }
      } else if (event.keyCode === 38) {
        //arrow up
        if (this.selectedItemIndex > 0) {
          this.selectedItemIndex--;
        } else {
          this.selectedItemIndex = this.items.length - 1;
        }
      } else if (event.keyCode === 13) {
        //enter
        if (this.items.length === 0) {
          this.doSearch(this.search, '');
        }
        this.goto(this.items[this.selectedItemIndex]);
      }
    },
    goto: function(location) {
      if (!location) {
        return;
      }
      if (!location.Source) {
        return;
      }
      if (!location.Source.Posisjon) {
        return;
      }
      if (!location.Source.Posisjon.X) {
        return;
      }
      if (!location.Source.Posisjon.Y) {
        return;
      }
      store.commit('setCoordinates', {
        coordinates: {
          lat: location.Source.Posisjon.Y,
          lng: location.Source.Posisjon.X,
          text: `<h4>${location.Source.Text}<br>${location.Source.PostNummer} ${location.Source.PostSted}<br>${location.Source.FylkeNavn}<br></h4>`,
          address: location.Source,
        },
      });
      this.items = [];
      this.selectedItemIndex = 0;
      store.commit('setShowIntro', false);
    },
  },
  watch: {
    search(val, oldval) {
      this.doSearch(val, oldval);
    },
  },
};
</script>

<style scoped>
@media (max-width: 47.99em) {
  .sunmap-search-wrapper.not-intro {
    display: flex;
    justify-content: center;
  }
}

.sunmap-search {
  position: relative;
  margin-bottom: 0.4em;
  border-radius: 0.1rem;
}

.sunmap-search.not-intro {
  width: 90%;
}

.sunmap-search svg {
  position: absolute;
  left: 0.6em;
  top: 50%;
  width: 2em;
  height: auto;
  transform: translateY(-50%);
}

.sunmap-search svg.test {
  fill: red;
}

.sunmap-search input {
  padding: 1em 0 0.8em 3em;
  margin: 0;
}

.sunmap-search__results {
  list-style: none;
  position: absolute;
  z-index: 1;
  top: 100%;
  margin: 0.1em 0 0;
  padding: 0;
  background-color: rgba(255, 255, 255, 0.7);
  width: 100%;
  border-radius: 0.1rem;
}

.sunmap-search__results li {
  display: block;
  padding: 0.7em 0em 0.4em 1em;
}

.sunmap-search__results--selected {
  background-color: rgb(0, 149, 214);
  color: #fff;
  text-decoration: underline;
}
</style>
